module.exports = {"closeButtonText":"Fechar","thumbNailAlt":"Imagem anterior","next":"Próxima página","previous":"Página anterior","addNote":"Adicionar uma anotação..."}


//////////////////
// WEBPACK FOOTER
// ./translations/pt-BR.json
// module id = 37
// module chunks = 0